export const loadCanvas = (canvas, fileName) => () =>
  Promise.resolve({ canvas, fileName });
